import { render } from "./ListInfo.vue?vue&type=template&id=74049350"
import script from "./ListInfo.vue?vue&type=script&lang=js"
export * from "./ListInfo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__